export const invoicesEndpoints = {
  getStoreInvoices: 'getStoreInvoices',
  getTaxRules: 'getTaxRules',
} as const;

export const invoicesTags = {
  storeInvoices: 'storeInvoices',
  taxRules: 'taxRules',
} as const;

export const GET_STORE_INVOICES_URL = '/v1/invoices/store';
export const GET_TAX_RULES_URL = '/v1/invoices/tax-rules';
